// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cxplnvfimnyjiyhjwvnb.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN4cGxudmZpbW55aml5aGp3dm5iIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk5NTQ5ODgsImV4cCI6MjA2NTUzMDk4OH0.zoeFEZJjwec3OqKXw3_8tpG6Cw__Q9Z_QAygbuc6OOg";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);